import React from "react";
import GATSBY_COMPILED_MDX from "/builds/trustwise/trustwise.io/src/content/mdx/solutions/data-rooms.mdx";
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import DOMPurify from 'isomorphic-dompurify';
import '../../styles/solution-detail.css';
import {_} from '../../utils/l10n';
import {ButtonLink} from '../../components/generic/ButtonLink';
import {Layout} from '../../components/layout';
import {Seo} from '../../components/seo';
import {TwoColBorderedGridList} from '../../components/generic/TwoColBorderedGridList';
import {PricingPlanTile} from '../../components/solutions/PricingPlanTile';
import {ButtonTypes} from '../../consts/button';
import {HowToStartList} from '../../components/solutions/HowToStartList';
import {jsx as _jsx} from "react/jsx-runtime";
import {jsxs as _jsxs} from "react/jsx-runtime";
const SolutionDetail = _ref => {
  let {data} = _ref;
  const {mdx: {frontmatter: {title, excerpt, buttons, detail_image, detail_image_alt, features_subtitle, features, pricing_plans, pricing_plans_subtitle, how_to_start_show_download_step, how_to_start_steps}}} = data;
  const imageData = getImage(detail_image);
  const showHowToStart = how_to_start_show_download_step || (how_to_start_steps === null || how_to_start_steps === void 0 ? void 0 : how_to_start_steps.length) > 0;
  return _jsxs(Layout, {
    contentClassName: "solution-detail",
    children: [_jsx(Seo, {
      title: title === null || title === void 0 ? void 0 : title.replace('<sup>®</sup>', '')
    }), _jsxs("section", {
      className: "solution-detail-page-top solution-content-container",
      children: [_jsxs("div", {
        children: [_jsx("h1", {
          className: "solution-detail-title title-1",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(title)
          }
        }), _jsx("div", {
          className: "solution-detail-description",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(excerpt)
          }
        }), _jsx("div", {
          className: "solution-detail-cta",
          children: buttons === null || buttons === void 0 ? void 0 : buttons.map(_ref2 => {
            let {label, url, is_primary} = _ref2;
            return _jsx(ButtonLink, {
              href: url,
              label: label,
              mode: is_primary ? ButtonTypes.PRIMARY : ButtonTypes.OUTLINE,
              size: "large"
            }, label);
          })
        })]
      }), imageData && _jsx(GatsbyImage, {
        image: imageData,
        alt: detail_image_alt !== null && detail_image_alt !== void 0 ? detail_image_alt : '',
        loading: "eager",
        objectFit: "contain",
        objectPosition: "center"
      })]
    }), features && _jsxs("section", {
      className: "solution-detail-features solution-content-container",
      children: [_jsx("h2", {
        className: "mono-space-text",
        children: _('Features')
      }), _jsx("h3", {
        className: "solution-detail-subtitle",
        children: features_subtitle
      }), _jsx(TwoColBorderedGridList, {
        items: features
      })]
    }), pricing_plans && _jsx("section", {
      className: "solution-detail-pricing",
      children: _jsxs("div", {
        className: "solution-content-container",
        children: [_jsx("h2", {
          className: "mono-space-text",
          children: _('Pricing')
        }), _jsx("h3", {
          className: "solution-detail-subtitle",
          children: pricing_plans_subtitle
        }), _jsx("ul", {
          className: "pricing-plan-list",
          children: pricing_plans.map(_ref3 => {
            let {title, subtitle, icon, custom_subtitle, custom_text, pricing_items, pricing_suffix, key_features, paid_features} = _ref3;
            return _jsx(PricingPlanTile, {
              icon: icon === null || icon === void 0 ? void 0 : icon.publicURL,
              title: title,
              subtitle: subtitle,
              customSubtitle: custom_subtitle,
              customText: custom_text,
              pricingItems: pricing_items,
              keyFeatures: key_features,
              pricingSuffix: pricing_suffix,
              paidFeatures: paid_features
            }, title);
          })
        })]
      })
    }), showHowToStart && _jsx("section", {
      className: "solution-detail-how-to-start page-padding-h",
      children: _jsxs("div", {
        className: "container",
        children: [_jsx("h2", {
          className: "solution-detail-subtitle solution-detail-how-to-start-subtitle",
          children: _('How to Start')
        }), _jsx(HowToStartList, {
          showDownloadStep: how_to_start_show_download_step,
          steps: how_to_start_steps
        })]
      })
    })]
  });
};
SolutionDetail
export default function GatsbyMDXWrapper(props) {
  return React.createElement(SolutionDetail, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "3657282894";
export const Head = () => _jsx("body", {
  className: "page-solution-detail"
});
